module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Italian Prince, Wedlocked Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/3.jpg"
    }
  })])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("There are times in a man’s life…")])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("when only seduction will settle old scores!")])])])])])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Pick up our exciting series of revenge-filled romances—they’re recommended and red-hot!")])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Available only from Harlequin Presents"), _c('sup', [_vm._v("®")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9d3838c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italianprincewedlockedwife_fm02.vue
// module id = 60
// module chunks = 0